import {
  Download,
  Hand,
  HandCoins,
  MoreHorizontal,
  Shuffle,
  UserCog,
} from 'lucide-react'

import { UiButton } from '@/ui/UiButton'
import {
  UiDropdownMenu,
  UiDropdownMenuContent,
  UiDropdownMenuItem,
  UiDropdownMenuSeparator,
  UiDropdownMenuTrigger,
} from '@/ui/UiDropdownMenu'

interface Props {
  actions: {
    visible: boolean
    canDelegate?: boolean
    canWithdraw?: boolean
    hasDelegation?: boolean
  }

  classNames?: {
    triggerClassName?: string
  }

  onDelegate(): void
  onUndelegate(): void
  onRedelegate(): void
  onWithdraw(): void
  onChangeOwner(): void
}

export function NftActionsDropdown({
  actions,
  onDelegate,
  onUndelegate,
  onRedelegate,
  onWithdraw,
  classNames,
  onChangeOwner,
}: Props) {
  if (!actions.visible) return null

  return (
    <UiDropdownMenu>
      <UiDropdownMenuTrigger className={classNames?.triggerClassName} asChild>
        <UiButton size='sm' className='rounded-full' variant='white'>
          <MoreHorizontal />
          Manage Shard
        </UiButton>
      </UiDropdownMenuTrigger>

      <UiDropdownMenuContent align='end' className='bg-input border-none'>
        {actions.hasDelegation ? (
          <>
            <UiDropdownMenuItem onSelect={onUndelegate}>
              <Hand />
              Undelegate
            </UiDropdownMenuItem>

            <UiDropdownMenuItem onSelect={onRedelegate}>
              <Shuffle />
              Redelegate
            </UiDropdownMenuItem>

            {actions.canWithdraw && (
              <>
                <UiDropdownMenuSeparator />
                <UiDropdownMenuItem onSelect={onWithdraw}>
                  <Download />
                  Withdraw
                </UiDropdownMenuItem>
              </>
            )}
          </>
        ) : (
          <>
            {actions.canDelegate && (
              <UiDropdownMenuItem onSelect={onDelegate}>
                <HandCoins />
                Delegate
              </UiDropdownMenuItem>
            )}

            {actions.canWithdraw && (
              <UiDropdownMenuItem onSelect={onWithdraw}>
                <Download />
                Withdraw
              </UiDropdownMenuItem>
            )}

            <UiDropdownMenuSeparator className='bg-white/10' />

            <UiDropdownMenuItem onSelect={onChangeOwner}>
              <UserCog />
              Change Owner
            </UiDropdownMenuItem>
          </>
        )}
      </UiDropdownMenuContent>
    </UiDropdownMenu>
  )
}
